import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Section } from '../layout';
import { NeonBorder } from '../common';
import { certifications } from '../../data';

const colorCycle: Array<'green' | 'cyan' | 'purple'> = ['green', 'cyan', 'purple'];

export function Certifications() {
  const { t } = useTranslation();

  return (
    <Section id="certifications" title={t('certifications.title')}>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {certifications.map((cert, index) => (
          <motion.div
            key={cert.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <NeonBorder color={colorCycle[index % colorCycle.length]} className="p-6 h-full">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-cyber-bg border border-current flex items-center justify-center text-2xl">
                  {cert.id === 'ccna' && '🌐'}
                  {cert.id === 'cpp' && '⚙️'}
                  {cert.id === 'rust' && '🦀'}
                  {cert.id === 'go' && '🐹'}
                  {cert.id === 'yocto' && '🐧'}
                </div>
                <h3 className="text-lg font-cyber text-cyber-text mb-2">
                  {t(cert.name)}
                </h3>
                <p className="text-sm text-cyber-cyan mb-3">
                  {t(cert.issuer)}
                </p>
                <p className="text-sm text-cyber-muted">
                  {t(cert.description)}
                </p>
              </div>
            </NeonBorder>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
